import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import React from "react";

const Loading = () => {
  return (
    <div>
      <DotLottieReact
      className="w-48"
      src="https://lottie.host/b89f063f-4d8e-4b97-8516-d7c2a9bdf2ea/atq45tJJyU.lottie"
      loop
      autoplay
    />
    </div>
  );
};

export default Loading;
